export default __webpack_public_path__ + "static/media/historique.415cdb65.svg";